import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { Button, IconContainer, CloseIconContainer, Text } from './styles';

const ICON_SIZES = {
  small: '17px',
  medium: '20px',
  large: '20px',
};

const TAG_ICON_SIZE = '12px';

export const Chip = ({
  checked = false,
  label,
  margin,
  onClick,
  showIcon,
  size = 'medium',
  tag = false,
}) => {
  return (
    <Button
      type="button"
      onClick={onClick}
      margin={margin}
      size={size}
      checked={checked}
      $tag={tag}
    >
      {showIcon === 'delete' && (
        <CloseIconContainer $tag={tag}>
          <Icon
            iconName={tag ? 'close' : 'close-circle'}
            alt="delete icon"
            size={tag ? TAG_ICON_SIZE : ICON_SIZES[size]}
            color={tag ? 'border.dark' : undefined}
            id="chip_delete"
          />
        </CloseIconContainer>
      )}
      <Text $tag={tag}>{label}</Text>
      {showIcon === 'check' && checked && (
        <IconContainer>
          <Icon
            iconName="check"
            alt="check icon"
            size={ICON_SIZES[size]}
            color="text.secondary"
            id="chip_check"
          />
        </IconContainer>
      )}
    </Button>
  );
};

Chip.displayName = 'Chip';

Chip.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  margin: PropTypes.string,
  onClick: PropTypes.func,
  showIcon: PropTypes.oneOf(['check', 'delete']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  tag: PropTypes.bool,
};
